import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { DreamSection } from './components/DreamSection';
import { WhatIsIt } from './components/WhatIsIt';
import { ContentCarousel } from './components/ContentCarousel';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { WhatsappProof } from './components/WhatsappProof';
import { Guarantee } from './components/Guarantee';
import { FinalCta } from './components/FinalCta';
import { Faq } from './components/Faq';
export function App() {
  return <div className="min-h-full w-full bg-paper text-ink" data-id="element-0" data-mp="2wjgu3r3habkn">
      <UrgencyBar data-id="element-1" data-mp="2whxd1y9zzwht" />
      <main data-id="element-2" data-mp="28u5y0mx2p5cu">
        <Hero data-id="element-3" data-mp="28tw4ipctkg2e" />
        <PainSection data-id="element-4" data-mp="28te21azkd5m1" />
        <DreamSection data-id="element-5" data-mp="28suveqfd63nb" />
        <WhatIsIt data-id="element-6" data-mp="28s2y9b64bxux" />
        <ContentCarousel data-id="element-7" data-mp="23vkvuhy9gblr" />
        <Bonuses data-id="element-8" data-mp="23u9t8lgjx9w8" />
        <Offer data-id="element-9" data-mp="23utcc5hxu4bu" />
        <Testimonials data-id="element-10" data-mp="23v2uj6wqr76z" />
        <WhatsappProof data-id="element-11" data-mp="3ijxqiu0iq6lh" />
        <Guarantee data-id="element-12" data-mp="3ikh5q2ysagvt" />
        <FinalCta data-id="element-13" data-mp="3ij64oawq3n8e" />
        <Faq data-id="element-14" data-mp="3ijpcgysnsv8p" />
      </main>
      <footer className="bg-ink px-5 py-10 text-white lg:px-8" data-id="element-15" data-mp="3mlja0y7k5j4n">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 text-sm text-white/60 sm:flex-row sm:items-center sm:justify-between" data-id="element-16" data-mp="3mjztr7lwj82v">
          <p className="font-bold uppercase tracking-wide text-white" data-id="element-17" data-mp="5yjsutqtdfe">
            Megapack Entrenador 360°
          </p>
          <p data-id="element-18" data-mp="2zlldgx6hkckm">
            Producto digital. Pago único de $24.999 por Mercado Pago. Garantía de 7
            días.
          </p>
        </div>
      </footer>
    </div>;
}